import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFingerPrintXEmployee } from "src/models/Stores/Employee.models";

interface FingerPrintXEmployeeState {
  fingerPrintXEmployees: IFingerPrintXEmployee[];
  fingerPrintXEmployeeToEdit: IFingerPrintXEmployee | null;
}

const initialState: FingerPrintXEmployeeState = {
  fingerPrintXEmployees: [],
  fingerPrintXEmployeeToEdit: null,
};

const fingerPrintXEmployeeSlice = createSlice({
  name: "FingerPrintXEmployee",
  initialState,
  reducers: {
    setFingerPrintXEmployeeList: (state, action: PayloadAction<IFingerPrintXEmployee[]>) => {
      state.fingerPrintXEmployees = action.payload;
    },
    concatListFingerPrintXEmployee: (
      state: FingerPrintXEmployeeState,
      action: PayloadAction<IFingerPrintXEmployee[]>
    ) => {
      state.fingerPrintXEmployees = [...state.fingerPrintXEmployees.concat(action.payload)];
    },
    setFingerPrintXEmployeeToEdit: (
      state,
      action: PayloadAction<IFingerPrintXEmployee | null>
    ) => {
      state.fingerPrintXEmployeeToEdit = action.payload;
    },
    addFingerPrintXEmployee: (state, action: PayloadAction<IFingerPrintXEmployee>) => {
      state.fingerPrintXEmployees.push(action.payload);
    },
    updateFingerPrintXEmployee: (state, action: PayloadAction<IFingerPrintXEmployee>) => {
      let itemIndex = state.fingerPrintXEmployees.findIndex(
        item => item.fingerPrintXEmployeeId === action.payload.fingerPrintXEmployeeId
      );
      if (itemIndex !== -1) state.fingerPrintXEmployees[itemIndex] = action.payload;
    },
    deleteFingerPrintXEmployee: (state, action: PayloadAction<number>) => {
      const newArray = state.fingerPrintXEmployees.filter(
        item => item.fingerPrintXEmployeeId !== action.payload
      );
      state.fingerPrintXEmployees = newArray;
    },
  },
});

export const {
  setFingerPrintXEmployeeList,
  concatListFingerPrintXEmployee,
  setFingerPrintXEmployeeToEdit,
  addFingerPrintXEmployee,
  updateFingerPrintXEmployee,
  deleteFingerPrintXEmployee,
} = fingerPrintXEmployeeSlice.actions;

export default fingerPrintXEmployeeSlice.reducer;
